var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavetwigs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6903 33.4548L23.685 33.4565C23.4345 33.5404 23.1372 33.5035 22.8773 33.3385L22.8631 33.3295L22.8483 33.3215L12.7233 27.8137L12.4846 27.6838L12.2457 27.8135L2.10511 33.3213L2.10503 33.3212L2.09391 33.3276C1.91951 33.4282 1.73778 33.4817 1.57812 33.4817C1.0242 33.4817 0.5 32.9708 0.5 32.2478V6.44275C0.5 4.27083 1.29848 2.81656 2.54474 1.88846C3.81404 0.943186 5.60785 0.5 7.65625 0.5H17.2969C19.3531 0.5 21.1472 0.943187 22.4206 1.88886C23.6712 2.81758 24.4774 4.27298 24.5 6.44541V32.2478C24.5 32.466 24.4526 32.6784 24.3642 32.8594C24.2171 33.1538 23.9757 33.3628 23.6903 33.4548ZM18.3594 9.7676H6.59375C5.60294 9.7676 4.875 10.6313 4.875 11.6105C4.875 12.5877 5.60255 13.4535 6.59375 13.4535H18.3594C19.3506 13.4535 20.0781 12.5877 20.0781 11.6105C20.0781 10.6313 19.3502 9.7676 18.3594 9.7676Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavetwigs);
export default __webpack_public_path__ + "static/media/save twigs.dcf95f37bd5c1b6a9377a802be91cc9e.svg";
export { ForwardRef as ReactComponent };